import Button from '@/components/Button';
import { ArrowRightIcon } from '@heroicons/react/24/solid';

export function ButtonGroup() {
  return (
    <div className="flex w-full flex-col gap-5 md:w-1/2 lg:flex-row xl:flex-row">
      <Button variant="primary" href="#PricingContactUsSection">
        Request pricing
      </Button>
      <Button variant="ghost-dark" outline href="/enterprise/demo/">
        Request a trial <ArrowRightIcon className="ml-2 size-5 lg:hidden" />
      </Button>
    </div>
  );
}
